import constants from "../constants";
const initialState = {
  currentUser: null,
  token: null,
  betPlaced: false,
  cashedOut: false,
  
};
function authReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_AUTH_DATA:
      return {
        ...state,
        currentUser: action.payload.currentUser,
        token: action.payload.token,
      };
    case constants.SET_BET_PLACED:
      return {
        ...state,
        betPlaced: action.payload.betPlaced,
      };
      case constants.SET_CASHED_OUT:
        return {
          ...state,
          cashedOut: action.payload.cashedOut,
        };
    default:
      return state;
  }
}
export default authReducer;
